/** Parse ISO / epoch-ms timestamps to ms, or null when unusable. */
export function parseTimestampMs(
  value: string | number | null | undefined
): number | null {
  if (value == null || value === "") {
    return null;
  }
  const ms = /^\d+$/.test(String(value))
    ? Number(value)
    : new Date(value).getTime();
  return Number.isNaN(ms) ? null : ms;
}
